import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { PageHeader } from "@/components/PageHeader";
import { KpiCards } from "@/features/dashboard/KpiCards";
import { MonthBreakdown } from "@/features/dashboard/MonthBreakdown";
import { MonthlyChart } from "@/features/dashboard/MonthlyChart";
import { OpenByCustomer } from "@/features/dashboard/OpenByCustomer";
import { get } from "@/lib/api";
import { currentMonth, today } from "@/lib/format";
import type { Dashboard } from "@/lib/types";

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

export function Uebersicht() {
  const [sp, setSp] = useSearchParams();
  const m = sp.get("month");
  const month = m && MONTH.test(m) ? m : currentMonth();
  const setMonth = (next: string) => setSp(next === currentMonth() ? {} : { month: next }, { replace: true, preventScrollReset: true });
  // Always fresh on arrival: bookings or invoices may have changed elsewhere.
  const d = useQuery({ queryKey: ["dashboard"], queryFn: () => get<Dashboard>("/api/dashboard"), staleTime: 0 });

  return (
    <div className="space-y-8">
      <PageHeader title="Übersicht" />
      {d.isError && <p className="text-sm text-destructive">{d.error.message}</p>}
      {d.isPending && (
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          {Array.from({ length: 4 }, (_, i) => <div key={i} className="h-[6.5rem] animate-pulse rounded-xl bg-muted motion-reduce:animate-none" />)}
        </div>
      )}
      {d.data && (
        <>
          <KpiCards d={d.data} today={today()} />
          <OpenByCustomer d={d.data} />
          <div className="grid gap-8 lg:grid-cols-[3fr_2fr]">
            <MonthlyChart months={d.data.months} selected={month} onSelect={setMonth} />
            <MonthBreakdown month={month} onMonth={setMonth} />
          </div>
        </>
      )}
    </div>
  );
}
